import { io } from "socket.io-client";
import config from "../config";

let socket = null;

export const initSocket = (url) => {
  if (socket?.connected) return socket;
  console.log("ALPHA SOCKET URL : ",url);
  socket = io(url, {
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
  });

  socket.on("connect", () => console.log("Socket connected:", socket.id));
  socket.on("disconnect", () => console.log("Socket disconnected"));
  socket.on("connect_error", (error) => console.error("Socket connection error:", error));

  return socket;
};

export const getSocket = (url) => {
  if (!socket) return initSocket(url);
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const EmitEvent = (creative_id,data) => {
  socket.emit('joinCreativeRoom',creative_id);
  socket.emit('newLogMessage',{creative_id,log:data})
  socket.emit('leaveCreativeRoom',creative_id)
}

